/* raw layout hash: _default-web-layout-1ghj3iy:5c00d03b3959d538280d5b7eb397e4f325c30517295201f91146fd412ff02ae9 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from './nav/AppNavbar.jsx';
import AppFooter from './nav/AppFooter.jsx';

/**
 * Default authenticated web shell — RawHTMLDesign/layouts/_default-web-layout-1ghj3iy.html.
 * A distinct raw layout capture of the same default web shell (identical
 * navbar/menu/footer chrome to _default-web-layout), so its structure is
 * built from the same shared AppNavbar/AppFooter sub-components rather than
 * duplicated markup. Reused by every page whose page_layout node is
 * "_default-web-layout-1ghj3iy".
 */
export default function DefaultWebLayoutAlt1() {
  return (
    <div className="app-shell-web">
      <AppNavbar />

      <main>
        <Outlet />
      </main>

      <AppFooter />
    </div>
  );
}
